import React, { useEffect } from 'react'
import { ADD_MORE_COVERS_TRAVEL_ENHANCE_YOUR_COVERAGE, ADD_MORE_COVERS_TRAVEL_REVIEW_AND_CONFIRM } from './data';
import { AnimatePresence, motion } from "framer-motion";
import ReviewAndConfirmTravelPage from './reviewAndConfirmTravelPage';
import useTravelAddMoreCoversFlow from '../../../../hooks/useTravelAddMoreCoversFlow';
import { ADD_MORE_COVERS_FLOW_TRAVEL } from './data';
import { useDispatch, useSelector } from 'react-redux';
import { policyView, PolicyViewResponse } from '../../../../redux/features/motor/getQuoteSlice';
import { useParams, useNavigate } from 'react-router-dom';
import EnhanceYourCoverageTravelPage from './enhanceYourCoverageTravelPage';
import { getClientSource } from "../../../../utils/getClientSource";
import { clearCancellationState } from '../../../../redux/features/endorsements/cancellationSlice';
import CryptoJS from "crypto-js";

const AddMoreCoversTravel = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const policyDetails = useSelector(PolicyViewResponse);
    const { policy_id } = useParams();
    const { currentStep, handleFlowChange } = useTravelAddMoreCoversFlow();

    // Decode policy number from URL
    const policyNumber = decodeURIComponent(policy_id);

    const handleNavigationToPolicyOverview = () => {
        // We need to recreate the encrypted policy ID to navigate back
        const secretKey = "i-hate-meej";
        const encryptedValue = CryptoJS.AES.encrypt(policyNumber, secretKey).toString();
        
        // Convert to URL-safe format (same as policy card)
        const urlSafeEncryptedValue = encryptedValue
            .split("+")
            .join("-") // Replace '+' with '-'
            .split("/")
            .join("_") // Replace '/' with '_'
            .split("=")
            .join(""); // Remove '=' padding
        
        navigate(`/travel-insurance/policy-overview/${urlSafeEncryptedValue}?tabType=ManagePolicy`);
    };

    // Initialize the travel flow only when component first mounts and not already initialized
    useEffect(() => {
        console.log("🆕 [v2.0] Flow initialization check - BUILD_VERSION_2024");
        console.log("🔄 Current step:", currentStep?.name);
        
        // Only initialize if we don't have a current step set yet
        if (!currentStep?.name) {
            console.log("🔄 [v2.0] Initializing travel add more covers flow for first time");
            handleFlowChange(ADD_MORE_COVERS_FLOW_TRAVEL, 0, 0);
        } else {
            console.log("🔄 [v2.0] Flow already initialized, current step:", currentStep.name);
        }
    }, []); // Empty dependency array - run only once
    
    // Debug flow state changes
    useEffect(() => {
        console.log("🔄 Flow state changed - currentStep:", currentStep?.name);
    }, [currentStep?.name]);

    useEffect(() => {
        // Reset any previous cancellation state
        dispatch(clearCancellationState());
        
        // Load policy data if not already loaded
        const polReq = {
            PolicyNumber: policy_id,
            Channel: getClientSource(),
        };
        dispatch(policyView(polReq));
    }, [dispatch, policy_id]);

    const PageRenderer = () => {
        console.log("📄 PageRenderer - currentStep:", currentStep);
        console.log("📄 PageRenderer - step name:", currentStep?.name);
        console.log("📄 Available constants:", {
            ENHANCE: ADD_MORE_COVERS_TRAVEL_ENHANCE_YOUR_COVERAGE,
            REVIEW: ADD_MORE_COVERS_TRAVEL_REVIEW_AND_CONFIRM
        });
        
        switch (currentStep?.name) {
            case ADD_MORE_COVERS_TRAVEL_ENHANCE_YOUR_COVERAGE:
                console.log("📄 Rendering EnhanceYourCoverageTravelPage");
                return <EnhanceYourCoverageTravelPage handleNavigationToPolicyOverview={handleNavigationToPolicyOverview} />
            case ADD_MORE_COVERS_TRAVEL_REVIEW_AND_CONFIRM:
                console.log("📄 Rendering ReviewAndConfirmTravelPage");
                return <ReviewAndConfirmTravelPage handleNavigationToPolicyOverview={handleNavigationToPolicyOverview} />
            default:
                console.log("📄 Rendering default EnhanceYourCoverageTravelPage");
                return <EnhanceYourCoverageTravelPage handleNavigationToPolicyOverview={handleNavigationToPolicyOverview} />
        }
    };

    return (
        <>
            <AnimatePresence mode="popLayout" initial={false}>
                <motion.div
                    key={currentStep?.name || "step"}
                    initial={{ opacity: 0, x: 12 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -12 }}
                    transition={{ duration: 0.22, ease: "easeOut" }}
                >
                    {PageRenderer()}
                </motion.div>
            </AnimatePresence>
            <div id="travel-footer-portal" />
            <div id="home-footer-portal" />
        </>
    )
}

export default AddMoreCoversTravel;